<template>
    <div id="material-kit" :class="{ 'nav-open': NavbarStore.showNavbar }">
        <div class="wrapper wrapper-full-page" :class="{ 'nav-open': $sidebar.showSidebar }" >
            <router-view name="header"/>
            <router-view name="menu"/>
            <div id="view-container" class="view-container">
                <div class="wrapper wrapper-full-page">
                    <router-view name="sidebar"/>
                    <router-view/>
                </div>
            </div>
            <loading :active.sync="LoadingStore.isLoading" id="loading-global" />
        </div>
        <router-view name="footer" v-if="FooterStore.showFooter"/>

        <!-- AI Chatbot FAB -->
        <div v-if="showChatbotFab" class="ai-chatbot-wrapper">
            <SpeedDial :model="aiMenuItems" direction="up" :tooltip-options="{ position: 'left' }" @show="aiOpen = true" @hide="aiOpen = false">
                <template #button="{ toggle }">
                    <button class="ai-fab-main-btn" @click="onFabToggle(toggle)">
                        <img v-if="!aiOpen" src="@/assets/img/ai-chatbot-bubble-white.svg" class="ai-fab-btn-icon" alt="AI"/>
                        <span v-else class="ai-fab-close">&#x2715;</span>
                    </button>
                </template>
                <template #item="{ item }">
                    <div class="ai-fab-item">
                        <span class="ai-fab-label">{{ item.label }}</span>
                        <button class="p-speeddial-action ai-fab-action" @click="item.command()">
                            <img :src="item.icon" :alt="item.label" class="ai-fab-action-icon"/>
                            <md-tooltip md-direction="left">{{ item.tooltip }}</md-tooltip>
                        </button>
                    </div>
                </template>
            </SpeedDial>
        </div>
    </div>
</template>

<script>
import SpeedDial from 'primevue/speeddial';
import {UserDataHelper} from "@/api/helpers";
import {USER_LOG_ACTION} from "@/layout/Constants";

export default {
    name: 'App',
    components: {SpeedDial},
    computed: {
        showChatbotFab() {
            return !!this.$store.state.UserInfo.token && this.$route.name !== 'chatbot';
        }
    },
    methods: {
        onFabToggle(toggle) {
            if (!this.aiOpen) {
                UserDataHelper.createUserLog(USER_LOG_ACTION.CHATBOT_FAB_OPEN);
            }
            toggle();
        },
    },
    watch: {
        showChatbotFab(val) {
            if (val) this.aiOpen = false;
        }
    },
    data() {
        return {
            aiOpen: false,
            aiMenuItems: [
                {
                    label: 'AI Platform Help',
                    tooltip: 'Ask AI anything about generic note investing: strategies, market trends, industry terms, and more',
                    icon: require('@/assets/img/ai-platform-help-white.svg'),
                    command: () => {
                        UserDataHelper.createUserLog(USER_LOG_ACTION.CHATBOT_FAB_ITEM_PLATFORM);
                        this.$router.push({ name: 'chatbot', query: { questionType: 'PLATFORM' } }).catch(() => {});
                    }
                },
                {
                    label: 'AI Note Analysis',
                    tooltip: 'Select notes and ask AI anything: evaluate note, compare performance, get insights, and more',
                    icon: require('@/assets/img/ai-note-analysis-white.svg'),
                    command: () => {
                        UserDataHelper.createUserLog(USER_LOG_ACTION.CHATBOT_FAB_ITEM_NOTE_INSIGHT);
                        const selectedIds = this.$store.state.Chatbot.selectedNoteIds;
                        const query = { questionType: 'NOTE_INSIGHT' };
                        if (selectedIds && selectedIds.length) {
                            query.noteIds = selectedIds.join(',');
                        }
                        this.$router.push({ name: 'chatbot', query }).catch(() => {});
                    }
                },
                {
                    label: 'AI Business Questions',
                    tooltip: 'Ask AI anything about note investing: strategies, market trends, industry terms, and more',
                    icon: require('@/assets/img/ai-business-questions-white.svg'),
                    command: () => {
                        UserDataHelper.createUserLog(USER_LOG_ACTION.CHATBOT_FAB_ITEM_DOMAIN);
                        this.$router.push({ name: 'chatbot', query: { questionType: 'DOMAIN' } }).catch(() => {});
                    }
                }
            ]
        };
    }
};
</script>
